import AppContext, { AppContextProps } from 'containers/context/Context'
import { useAccessControl } from 'helpers/permissionHelper'
import React, { useContext } from 'react'

export interface AccessControlProps {
  acl: string | string[]
  children: React.ReactNode
}

const ACLGuard: React.FC<AccessControlProps> = ({ acl, children }) => {
  const context = useContext<AppContextProps>(AppContext);

  const isPermit = useAccessControl(acl, context)

  if (!isPermit) {
    return null
  }

  return <>{children}</>
}

export default ACLGuard
